import React, {useEffect, useMemo} from 'react';
import { Box, CircularProgress } from '@mui/material';
import {useLanguage} from "../../context/LanguageContext";
import useGetConfigPowerBeoneReport from "../../hooks/PowerBI/useGetConfigPowerBeoneReport";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./ReportingDataviz.css";
import { PageContainer } from '../../components/Common';
import { useAuthenticatedFetchWithWorkspace } from '../../hooks/Keycloak';



export interface ReportingProps {
    labelReport?: string,
    forcedUserId?: number,
}

interface EmbedSettings {
    filterPaneEnabled?: boolean;
    navContentPaneEnabled?: boolean;
    localeSettings?: {
        language?: string;
        formatLocale?: string;
    };
}

interface EmbedConfigProps {
    type?: string,
    id?: string,
    embedUrl?: string,
    accessToken?: string,
    tokenType?: models.TokenType.Embed,
    settings: EmbedSettings
}


const ReportingDataviz = (props: ReportingProps) => {
    const {language, formatLocale} = useLanguage();
    const { fetchPowerBeoneConfigReport, data: reportDatas, dataWorkspaceId, loading } = useGetConfigPowerBeoneReport();
    const { isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const hasCurrentWorkspaceReport = !!workspaceId && dataWorkspaceId === workspaceId;

    const embedConfig = useMemo<EmbedConfigProps | undefined>(() => {
        if (!reportDatas || !hasCurrentWorkspaceReport) return undefined;
        return {
            type: reportDatas['type'],
            id: reportDatas['reportId'],
            embedUrl: reportDatas['embedUrl'],
            accessToken: reportDatas['accessToken'],
            tokenType: models.TokenType.Embed,
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
                localeSettings: { language: language, formatLocale: formatLocale },
            },
        };
    }, [reportDatas, hasCurrentWorkspaceReport, language, formatLocale]);

    useEffect(() => {
        if (!isReady) return;
        fetchPowerBeoneConfigReport({ 'labelReport' : props.labelReport, 'forcedUserId' : '15316', formatLocale });
    }, [props.labelReport, formatLocale, fetchPowerBeoneConfigReport, isReady, workspaceId]);

/*
    function buildEmbedConfig(){
        if(!isEmpty(reportDatas?.reportRef)) {
            let myEmbedConfig = {
                type: reportDetails['type'],
                id: reportDetails['reportId'],
                embedUrl: reportDetails['embedUrl'],
                accessToken: reportDetails['accessToken'],
                tokenType: models.TokenType.Embed,
                settings: {
                    filterPaneEnabled: false,
                    navContentPaneEnabled: false
                }
            };

            if (props.dataKpi !== undefined && props.dataKpi.labelReport) {
                let page = myReport.pages.filter(page => page.displayName == props.dataKpi.page );
                page = page[0];

                let embedFilters = {
                    filters: [{
                        $schema: "http://powerbi.com/product/schema#basic",
                        target: {
                            table: "dataviz person_stat",
                            column: "person_id"
                        },
                        operator: "In",
                        values: [parseInt(props.dataKpi.personId)],
                        filterType: models.FilterType.BasicFilter,
                        requireSingleSelection: true
                    }],
                    pageName: page.name
                };
                myEmbedConfig = Object.assign(myEmbedConfig, embedFilters);
            }
            setEmbedConfig(myEmbedConfig);
            setIsEmbedConfigBuild(true);
        }
    }
*/

    return (
        <PageContainer isDatavizPage={true}>
            {embedConfig ? (
            <PowerBIEmbed key={`${workspaceId || 'no-workspace'}-${language}-${embedConfig.id || ''}-${embedConfig.accessToken || ''}`}
                embedConfig={embedConfig}
                          cssClassName={
                              "customerContainerReporting"
                          }

            ></PowerBIEmbed>)
                : (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '60vh',
                        }}
                    >
                        {(loading || isReady) && <CircularProgress size={32} />}
                    </Box>
                )
            }
        </PageContainer>
    );
};

export default ReportingDataviz;
